export const location = [{
  'key': 110000,
  'label': '北京',
  'children': [{
    'key': 110101,
    'label': '东城区'
  }, {
    'key': 110102,
    'label': '西城区'
  }, {
    'key': 110105,
    'label': '朝阳区'
  }, {
    'key': 110106,
    'label': '丰台区'
  }, {
    'key': 110107,
    'label': '石景山区'
  }, {
    'key': 110108,
    'label': '海淀区'
  }, {
    'key': 110109,
    'label': '门头沟区'
  }, {
    'key': 110111,
    'label': '房山区'
  }, {
    'key': 110112,
    'label': '通州区'
  }, {
    'key': 110113,
    'label': '顺义区'
  }, {
    'key': 110114,
    'label': '昌平区'
  }, {
    'key': 110115,
    'label': '大兴区'
  }, {
    'key': 110116,
    'label': '怀柔区'
  }, {
    'key': 110117,
    'label': '平谷区'
  }, {
    'key': 110118,
    'label': '密云区'
  }, {
    'key': 110119,
    'label': '延庆区'
  }]
}, {
  'key': 120000,
  'label': '天津',
  'children': [{
    'key': 120101,
    'label': '和平区'
  }, {
    'key': 120102,
    'label': '河东区'
  }, {
    'key': 120103,
    'label': '河西区'
  }, {
    'key': 120104,
    'label': '南开区'
  }, {
    'key': 120105,
    'label': '河北区'
  }, {
    'key': 120106,
    'label': '红桥区'
  }, {
    'key': 120110,
    'label': '东丽区'
  }, {
    'key': 120111,
    'label': '西青区'
  }, {
    'key': 120112,
    'label': '津南区'
  }, {
    'key': 120113,
    'label': '北辰区'
  }, {
    'key': 120114,
    'label': '武清区'
  }, {
    'key': 120115,
    'label': '宝坻区'
  }, {
    'key': 120116,
    'label': '滨海新区'
  }, {
    'key': 120117,
    'label': '宁河区'
  }, {
    'key': 120118,
    'label': '静海区'
  }, {
    'key': 120119,
    'label': '蓟州区'
  }]
}, {
  'key': 130000,
  'label': '河北',
  'children': [{
    'key': 130100,
    'label': '石家庄市'
  }, {
    'key': 130200,
    'label': '唐山市'
  }, {
    'key': 130300,
    'label': '秦皇岛市'
  }, {
    'key': 130400,
    'label': '邯郸市'
  }, {
    'key': 130500,
    'label': '邢台市'
  }, {
    'key': 130600,
    'label': '保定市'
  }, {
    'key': 130700,
    'label': '张家口市'
  }, {
    'key': 130800,
    'label': '承德市'
  }, {
    'key': 130900,
    'label': '沧州市'
  }, {
    'key': 131000,
    'label': '廊坊市'
  }, {
    'key': 131100,
    'label': '衡水市'
  }]
}, {
  'key': 140000,
  'label': '山西',
  'children': [{
    'key': 140100,
    'label': '太原市'
  }, {
    'key': 140200,
    'label': '大同市'
  }, {
    'key': 140300,
    'label': '阳泉市'
  }, {
    'key': 140400,
    'label': '长治市'
  }, {
    'key': 140500,
    'label': '晋城市'
  }, {
    'key': 140600,
    'label': '朔州市'
  }, {
    'key': 140700,
    'label': '晋中市'
  }, {
    'key': 140800,
    'label': '运城市'
  }, {
    'key': 140900,
    'label': '忻州市'
  }, {
    'key': 141000,
    'label': '临汾市'
  }, {
    'key': 141100,
    'label': '吕梁市'
  }]
}, {
  'key': 150000,
  'label': '内蒙古',
  'children': [{
    'key': 150100,
    'label': '呼和浩特市'
  }, {
    'key': 150200,
    'label': '包头市'
  }, {
    'key': 150300,
    'label': '乌海市'
  }, {
    'key': 150400,
    'label': '赤峰市'
  }, {
    'key': 150500,
    'label': '通辽市'
  }, {
    'key': 150600,
    'label': '鄂尔多斯市'
  }, {
    'key': 150700,
    'label': '呼伦贝尔市'
  }, {
    'key': 150800,
    'label': '巴彦淖尔市'
  }, {
    'key': 150900,
    'label': '乌兰察布市'
  }, {
    'key': 152200,
    'label': '兴安盟'
  }, {
    'key': 152500,
    'label': '锡林郭勒盟'
  }, {
    'key': 152900,
    'label': '阿拉善盟'
  }]
}, {
  'key': 210000,
  'label': '辽宁',
  'children': [{
    'key': 210100,
    'label': '沈阳市'
  }, {
    'key': 210200,
    'label': '大连市'
  }, {
    'key': 210300,
    'label': '鞍山市'
  }, {
    'key': 210400,
    'label': '抚顺市'
  }, {
    'key': 210500,
    'label': '本溪市'
  }, {
    'key': 210600,
    'label': '丹东市'
  }, {
    'key': 210700,
    'label': '锦州市'
  }, {
    'key': 210800,
    'label': '营口市'
  }, {
    'key': 210900,
    'label': '阜新市'
  }, {
    'key': 211000,
    'label': '辽阳市'
  }, {
    'key': 211100,
    'label': '盘锦市'
  }, {
    'key': 211200,
    'label': '铁岭市'
  }, {
    'key': 211300,
    'label': '朝阳市'
  }, {
    'key': 211400,
    'label': '葫芦岛市'
  }]
}, {
  'key': 220000,
  'label': '吉林',
  'children': [{
    'key': 220100,
    'label': '长春市'
  }, {
    'key': 220200,
    'label': '吉林市'
  }, {
    'key': 220300,
    'label': '四平市'
  }, {
    'key': 220400,
    'label': '辽源市'
  }, {
    'key': 220500,
    'label': '通化市'
  }, {
    'key': 220600,
    'label': '白山市'
  }, {
    'key': 220700,
    'label': '松原市'
  }, {
    'key': 220800,
    'label': '白城市'
  }, {
    'key': 222400,
    'label': '延边朝鲜族自治州'
  }]
}, {
  'key': 230000,
  'label': '黑龙江',
  'children': [{
    'key': 230100,
    'label': '哈尔滨市'
  }, {
    'key': 230200,
    'label': '齐齐哈尔市'
  }, {
    'key': 230300,
    'label': '鸡西市'
  }, {
    'key': 230400,
    'label': '鹤岗市'
  }, {
    'key': 230500,
    'label': '双鸭山市'
  }, {
    'key': 230600,
    'label': '大庆市'
  }, {
    'key': 230700,
    'label': '伊春市'
  }, {
    'key': 230800,
    'label': '佳木斯市'
  }, {
    'key': 230900,
    'label': '七台河市'
  }, {
    'key': 231000,
    'label': '牡丹江市'
  }, {
    'key': 231100,
    'label': '黑河市'
  }, {
    'key': 231200,
    'label': '绥化市'
  }, {
    'key': 232700,
    'label': '大兴安岭地区'
  }]
}, {
  'key': 310000,
  'label': '上海',
  'children': [{
    'key': 310101,
    'label': '黄浦区'
  }, {
    'key': 310104,
    'label': '徐汇区'
  }, {
    'key': 310105,
    'label': '长宁区'
  }, {
    'key': 310106,
    'label': '静安区'
  }, {
    'key': 310107,
    'label': '普陀区'
  }, {
    'key': 310109,
    'label': '虹口区'
  }, {
    'key': 310110,
    'label': '杨浦区'
  }, {
    'key': 310112,
    'label': '闵行区'
  }, {
    'key': 310113,
    'label': '宝山区'
  }, {
    'key': 310114,
    'label': '嘉定区'
  }, {
    'key': 310115,
    'label': '浦东新区'
  }, {
    'key': 310116,
    'label': '金山区'
  }, {
    'key': 310117,
    'label': '松江区'
  }, {
    'key': 310118,
    'label': '青浦区'
  }, {
    'key': 310120,
    'label': '奉贤区'
  }, {
    'key': 310151,
    'label': '崇明区'
  }]
}, {
  'key': 320000,
  'label': '江苏',
  'children': [{
    'key': 320100,
    'label': '南京市'
  }, {
    'key': 320200,
    'label': '无锡市'
  }, {
    'key': 320300,
    'label': '徐州市'
  }, {
    'key': 320400,
    'label': '常州市'
  }, {
    'key': 320500,
    'label': '苏州市'
  }, {
    'key': 320600,
    'label': '南通市'
  }, {
    'key': 320700,
    'label': '连云港市'
  }, {
    'key': 320800,
    'label': '淮安市'
  }, {
    'key': 320900,
    'label': '盐城市'
  }, {
    'key': 321000,
    'label': '扬州市'
  }, {
    'key': 321100,
    'label': '镇江市'
  }, {
    'key': 321200,
    'label': '泰州市'
  }, {
    'key': 321300,
    'label': '宿迁市'
  }]
}, {
  'key': 330000,
  'label': '浙江',
  'children': [{
    'key': 330100,
    'label': '杭州市'
  }, {
    'key': 330200,
    'label': '宁波市'
  }, {
    'key': 330300,
    'label': '温州市'
  }, {
    'key': 330400,
    'label': '嘉兴市'
  }, {
    'key': 330500,
    'label': '湖州市'
  }, {
    'key': 330600,
    'label': '绍兴市'
  }, {
    'key': 330700,
    'label': '金华市'
  }, {
    'key': 330800,
    'label': '衢州市'
  }, {
    'key': 330900,
    'label': '舟山市'
  }, {
    'key': 331000,
    'label': '台州市'
  }, {
    'key': 331100,
    'label': '丽水市'
  }]
}, {
  'key': 340000,
  'label': '安徽',
  'children': [{
    'key': 340100,
    'label': '合肥市'
  }, {
    'key': 340200,
    'label': '芜湖市'
  }, {
    'key': 340300,
    'label': '蚌埠市'
  }, {
    'key': 340400,
    'label': '淮南市'
  }, {
    'key': 340500,
    'label': '马鞍山市'
  }, {
    'key': 340600,
    'label': '淮北市'
  }, {
    'key': 340700,
    'label': '铜陵市'
  }, {
    'key': 340800,
    'label': '安庆市'
  }, {
    'key': 341000,
    'label': '黄山市'
  }, {
    'key': 341100,
    'label': '滁州市'
  }, {
    'key': 341200,
    'label': '阜阳市'
  }, {
    'key': 341300,
    'label': '宿州市'
  }, {
    'key': 341500,
    'label': '六安市'
  }, {
    'key': 341600,
    'label': '亳州市'
  }, {
    'key': 341700,
    'label': '池州市'
  }, {
    'key': 341800,
    'label': '宣城市'
  }]
}, {
  'key': 350000,
  'label': '福建',
  'children': [{
    'key': 350100,
    'label': '福州市'
  }, {
    'key': 350200,
    'label': '厦门市'
  }, {
    'key': 350300,
    'label': '莆田市'
  }, {
    'key': 350400,
    'label': '三明市'
  }, {
    'key': 350500,
    'label': '泉州市'
  }, {
    'key': 350600,
    'label': '漳州市'
  }, {
    'key': 350700,
    'label': '南平市'
  }, {
    'key': 350800,
    'label': '龙岩市'
  }, {
    'key': 350900,
    'label': '宁德市'
  }]
}, {
  'key': 360000,
  'label': '江西',
  'children': [{
    'key': 360100,
    'label': '南昌市'
  }, {
    'key': 360200,
    'label': '景德镇市'
  }, {
    'key': 360300,
    'label': '萍乡市'
  }, {
    'key': 360400,
    'label': '九江市'
  }, {
    'key': 360500,
    'label': '新余市'
  }, {
    'key': 360600,
    'label': '鹰潭市'
  }, {
    'key': 360700,
    'label': '赣州市'
  }, {
    'key': 360800,
    'label': '吉安市'
  }, {
    'key': 360900,
    'label': '宜春市'
  }, {
    'key': 361000,
    'label': '抚州市'
  }, {
    'key': 361100,
    'label': '上饶市'
  }]
}, {
  'key': 370000,
  'label': '山东',
  'children': [{
    'key': 370100,
    'label': '济南市'
  }, {
    'key': 370200,
    'label': '青岛市'
  }, {
    'key': 370300,
    'label': '淄博市'
  }, {
    'key': 370400,
    'label': '枣庄市'
  }, {
    'key': 370500,
    'label': '东营市'
  }, {
    'key': 370600,
    'label': '烟台市'
  }, {
    'key': 370700,
    'label': '潍坊市'
  }, {
    'key': 370800,
    'label': '济宁市'
  }, {
    'key': 370900,
    'label': '泰安市'
  }, {
    'key': 371000,
    'label': '威海市'
  }, {
    'key': 371100,
    'label': '日照市'
  }, {
    'key': 371200,
    'label': '莱芜市'
  }, {
    'key': 371300,
    'label': '临沂市'
  }, {
    'key': 371400,
    'label': '德州市'
  }, {
    'key': 371500,
    'label': '聊城市'
  }, {
    'key': 371600,
    'label': '滨州市'
  }, {
    'key': 371700,
    'label': '菏泽市'
  }]
}, {
  'key': 410000,
  'label': '河南',
  'children': [{
    'key': 410100,
    'label': '郑州市'
  }, {
    'key': 410200,
    'label': '开封市'
  }, {
    'key': 410300,
    'label': '洛阳市'
  }, {
    'key': 410400,
    'label': '平顶山市'
  }, {
    'key': 410500,
    'label': '安阳市'
  }, {
    'key': 410600,
    'label': '鹤壁市'
  }, {
    'key': 410700,
    'label': '新乡市'
  }, {
    'key': 410800,
    'label': '焦作市'
  }, {
    'key': 410900,
    'label': '濮阳市'
  }, {
    'key': 411000,
    'label': '许昌市'
  }, {
    'key': 411100,
    'label': '漯河市'
  }, {
    'key': 411200,
    'label': '三门峡市'
  }, {
    'key': 411300,
    'label': '南阳市'
  }, {
    'key': 411400,
    'label': '商丘市'
  }, {
    'key': 411500,
    'label': '信阳市'
  }, {
    'key': 411600,
    'label': '周口市'
  }, {
    'key': 411700,
    'label': '驻马店市'
  }, {
    'key': 419001,
    'label': '济源市'
  }]
}, {
  'key': 420000,
  'label': '湖北',
  'children': [{
    'key': 420100,
    'label': '武汉市'
  }, {
    'key': 420200,
    'label': '黄石市'
  }, {
    'key': 420300,
    'label': '十堰市'
  }, {
    'key': 420500,
    'label': '宜昌市'
  }, {
    'key': 420600,
    'label': '襄阳市'
  }, {
    'key': 420700,
    'label': '鄂州市'
  }, {
    'key': 420800,
    'label': '荆门市'
  }, {
    'key': 420900,
    'label': '孝感市'
  }, {
    'key': 421000,
    'label': '荆州市'
  }, {
    'key': 421100,
    'label': '黄冈市'
  }, {
    'key': 421200,
    'label': '咸宁市'
  }, {
    'key': 421300,
    'label': '随州市'
  }, {
    'key': 422800,
    'label': '恩施土家族苗族自治州'
  }, {
    'key': 429004,
    'label': '仙桃市'
  }, {
    'key': 429005,
    'label': '潜江市'
  }, {
    'key': 429006,
    'label': '天门市'
  }, {
    'key': 429021,
    'label': '神农架林区'
  }]
}, {
  'key': 430000,
  'label': '湖南',
  'children': [{
    'key': 430100,
    'label': '长沙市'
  }, {
    'key': 430200,
    'label': '株洲市'
  }, {
    'key': 430300,
    'label': '湘潭市'
  }, {
    'key': 430400,
    'label': '衡阳市'
  }, {
    'key': 430500,
    'label': '邵阳市'
  }, {
    'key': 430600,
    'label': '岳阳市'
  }, {
    'key': 430700,
    'label': '常德市'
  }, {
    'key': 430800,
    'label': '张家界市'
  }, {
    'key': 430900,
    'label': '益阳市'
  }, {
    'key': 431000,
    'label': '郴州市'
  }, {
    'key': 431100,
    'label': '永州市'
  }, {
    'key': 431200,
    'label': '怀化市'
  }, {
    'key': 431300,
    'label': '娄底市'
  }, {
    'key': 433100,
    'label': '湘西土家族苗族自治州'
  }]
}, {
  'key': 440000,
  'label': '广东',
  'children': [{
    'key': 440100,
    'label': '广州市'
  }, {
    'key': 440200,
    'label': '韶关市'
  }, {
    'key': 440300,
    'label': '深圳市'
  }, {
    'key': 440400,
    'label': '珠海市'
  }, {
    'key': 440500,
    'label': '汕头市'
  }, {
    'key': 440600,
    'label': '佛山市'
  }, {
    'key': 440700,
    'label': '江门市'
  }, {
    'key': 440800,
    'label': '湛江市'
  }, {
    'key': 440900,
    'label': '茂名市'
  }, {
    'key': 441200,
    'label': '肇庆市'
  }, {
    'key': 441300,
    'label': '惠州市'
  }, {
    'key': 441400,
    'label': '梅州市'
  }, {
    'key': 441500,
    'label': '汕尾市'
  }, {
    'key': 441600,
    'label': '河源市'
  }, {
    'key': 441700,
    'label': '阳江市'
  }, {
    'key': 441800,
    'label': '清远市'
  }, {
    'key': 441900,
    'label': '东莞市'
  }, {
    'key': 442000,
    'label': '中山市'
  }, {
    'key': 445100,
    'label': '潮州市'
  }, {
    'key': 445200,
    'label': '揭阳市'
  }, {
    'key': 445300,
    'label': '云浮市'
  }]
}, {
  'key': 450000,
  'label': '广西',
  'children': [{
    'key': 450100,
    'label': '南宁市'
  }, {
    'key': 450200,
    'label': '柳州市'
  }, {
    'key': 450300,
    'label': '桂林市'
  }, {
    'key': 450400,
    'label': '梧州市'
  }, {
    'key': 450500,
    'label': '北海市'
  }, {
    'key': 450600,
    'label': '防城港市'
  }, {
    'key': 450700,
    'label': '钦州市'
  }, {
    'key': 450800,
    'label': '贵港市'
  }, {
    'key': 450900,
    'label': '玉林市'
  }, {
    'key': 451000,
    'label': '百色市'
  }, {
    'key': 451100,
    'label': '贺州市'
  }, {
    'key': 451200,
    'label': '河池市'
  }, {
    'key': 451300,
    'label': '来宾市'
  }, {
    'key': 451400,
    'label': '崇左市'
  }]
}, {
  'key': 460000,
  'label': '海南',
  'children': [{
    'key': 460100,
    'label': '海口市'
  }, {
    'key': 460200,
    'label': '三亚市'
  }, {
    'key': 460300,
    'label': '三沙市'
  }, {
    'key': 460400,
    'label': '儋州市'
  }, {
    'key': 469001,
    'label': '五指山市'
  }, {
    'key': 469002,
    'label': '琼海市'
  }, {
    'key': 469005,
    'label': '文昌市'
  }, {
    'key': 469006,
    'label': '万宁市'
  }, {
    'key': 469007,
    'label': '东方市'
  }, {
    'key': 469021,
    'label': '定安县'
  }, {
    'key': 469022,
    'label': '屯昌县'
  }, {
    'key': 469023,
    'label': '澄迈县'
  }, {
    'key': 469024,
    'label': '临高县'
  }, {
    'key': 469025,
    'label': '白沙黎族自治县'
  }, {
    'key': 469026,
    'label': '昌江黎族自治县'
  }, {
    'key': 469027,
    'label': '乐东黎族自治县'
  }, {
    'key': 469028,
    'label': '陵水黎族自治县'
  }, {
    'key': 469029,
    'label': '保亭黎族苗族自治县'
  }, {
    'key': 469030,
    'label': '琼中黎族苗族自治县'
  }]
}, {
  'key': 500000,
  'label': '重庆',
  'children': [{
    'key': 500101,
    'label': '万州区'
  }, {
    'key': 500102,
    'label': '涪陵区'
  }, {
    'key': 500103,
    'label': '渝中区'
  }, {
    'key': 500104,
    'label': '大渡口区'
  }, {
    'key': 500105,
    'label': '江北区'
  }, {
    'key': 500106,
    'label': '沙坪坝区'
  }, {
    'key': 500107,
    'label': '九龙坡区'
  }, {
    'key': 500108,
    'label': '南岸区'
  }, {
    'key': 500109,
    'label': '北碚区'
  }, {
    'key': 500110,
    'label': '綦江区'
  }, {
    'key': 500111,
    'label': '大足区'
  }, {
    'key': 500112,
    'label': '渝北区'
  }, {
    'key': 500113,
    'label': '巴南区'
  }, {
    'key': 500114,
    'label': '黔江区'
  }, {
    'key': 500115,
    'label': '长寿区'
  }, {
    'key': 500116,
    'label': '江津区'
  }, {
    'key': 500117,
    'label': '合川区'
  }, {
    'key': 500118,
    'label': '永川区'
  }, {
    'key': 500119,
    'label': '南川区'
  }, {
    'key': 500120,
    'label': '璧山区'
  }, {
    'key': 500151,
    'label': '铜梁区'
  }, {
    'key': 500152,
    'label': '潼南区'
  }, {
    'key': 500153,
    'label': '荣昌区'
  }, {
    'key': 500154,
    'label': '开州区'
  }, {
    'key': 500228,
    'label': '梁平县'
  }, {
    'key': 500229,
    'label': '城口县'
  }, {
    'key': 500230,
    'label': '丰都县'
  }, {
    'key': 500231,
    'label': '垫江县'
  }, {
    'key': 500232,
    'label': '武隆县'
  }, {
    'key': 500233,
    'label': '忠县'
  }, {
    'key': 500235,
    'label': '云阳县'
  }, {
    'key': 500236,
    'label': '奉节县'
  }, {
    'key': 500237,
    'label': '巫山县'
  }, {
    'key': 500238,
    'label': '巫溪县'
  }, {
    'key': 500240,
    'label': '石柱土家族自治县'
  }, {
    'key': 500241,
    'label': '秀山土家族苗族自治县'
  }, {
    'key': 500242,
    'label': '酉阳土家族苗族自治县'
  }, {
    'key': 500243,
    'label': '彭水苗族土家族自治县'
  }]
}, {
  'key': 510000,
  'label': '四川',
  'children': [{
    'key': 510100,
    'label': '成都市'
  }, {
    'key': 510300,
    'label': '自贡市'
  }, {
    'key': 510400,
    'label': '攀枝花市'
  }, {
    'key': 510500,
    'label': '泸州市'
  }, {
    'key': 510600,
    'label': '德阳市'
  }, {
    'key': 510700,
    'label': '绵阳市'
  }, {
    'key': 510800,
    'label': '广元市'
  }, {
    'key': 510900,
    'label': '遂宁市'
  }, {
    'key': 511000,
    'label': '内江市'
  }, {
    'key': 511100,
    'label': '乐山市'
  }, {
    'key': 511300,
    'label': '南充市'
  }, {
    'key': 511400,
    'label': '眉山市'
  }, {
    'key': 511500,
    'label': '宜宾市'
  }, {
    'key': 511600,
    'label': '广安市'
  }, {
    'key': 511700,
    'label': '达州市'
  }, {
    'key': 511800,
    'label': '雅安市'
  }, {
    'key': 511900,
    'label': '巴中市'
  }, {
    'key': 512000,
    'label': '资阳市'
  }, {
    'key': 513200,
    'label': '阿坝藏族羌族自治州'
  }, {
    'key': 513300,
    'label': '甘孜藏族自治州'
  }, {
    'key': 513400,
    'label': '凉山彝族自治州'
  }]
}, {
  'key': 520000,
  'label': '贵州',
  'children': [{
    'key': 520100,
    'label': '贵阳市'
  }, {
    'key': 520200,
    'label': '六盘水市'
  }, {
    'key': 520201,
    'label': '钟山区'
  }, {
    'key': 520300,
    'label': '遵义市'
  }, {
    'key': 520400,
    'label': '安顺市'
  }, {
    'key': 520500,
    'label': '毕节市'
  }, {
    'key': 520600,
    'label': '铜仁市'
  }, {
    'key': 522300,
    'label': '黔西南布依族苗族自治州'
  }, {
    'key': 522600,
    'label': '黔东南苗族侗族自治州'
  }, {
    'key': 522700,
    'label': '黔南布依族苗族自治州'
  }]
}, {
  'key': 530000,
  'label': '云南',
  'children': [{
    'key': 530100,
    'label': '昆明市'
  }, {
    'key': 530300,
    'label': '曲靖市'
  }, {
    'key': 530400,
    'label': '玉溪市'
  }, {
    'key': 530500,
    'label': '保山市'
  }, {
    'key': 530600,
    'label': '昭通市'
  }, {
    'key': 530700,
    'label': '丽江市'
  }, {
    'key': 530800,
    'label': '普洱市'
  }, {
    'key': 530900,
    'label': '临沧市'
  }, {
    'key': 532300,
    'label': '楚雄彝族自治州'
  }, {
    'key': 532500,
    'label': '红河哈尼族彝族自治州'
  }, {
    'key': 532600,
    'label': '文山壮族苗族自治州'
  }, {
    'key': 532800,
    'label': '西双版纳傣族自治州'
  }, {
    'key': 532900,
    'label': '大理白族自治州'
  }, {
    'key': 533100,
    'label': '德宏傣族景颇族自治州'
  }, {
    'key': 533300,
    'label': '怒江傈僳族自治州'
  }, {
    'key': 533400,
    'label': '迪庆藏族自治州'
  }]
}, {
  'key': 540000,
  'label': '西藏',
  'children': [{
    'key': 540100,
    'label': '拉萨市'
  }, {
    'key': 540200,
    'label': '日喀则市'
  }, {
    'key': 540300,
    'label': '昌都市'
  }, {
    'key': 540400,
    'label': '林芝市'
  }, {
    'key': 540500,
    'label': '山南市'
  }, {
    'key': 542400,
    'label': '那曲地区'
  }, {
    'key': 542500,
    'label': '阿里地区'
  }]
}, {
  'key': 610000,
  'label': '陕西',
  'children': [{
    'key': 610100,
    'label': '西安市'
  }, {
    'key': 610200,
    'label': '铜川市'
  }, {
    'key': 610300,
    'label': '宝鸡市'
  }, {
    'key': 610400,
    'label': '咸阳市'
  }, {
    'key': 610500,
    'label': '渭南市'
  }, {
    'key': 610600,
    'label': '延安市'
  }, {
    'key': 610700,
    'label': '汉中市'
  }, {
    'key': 610800,
    'label': '榆林市'
  }, {
    'key': 610900,
    'label': '安康市'
  }, {
    'key': 611000,
    'label': '商洛市'
  }]
}, {
  'key': 620000,
  'label': '甘肃',
  'children': [{
    'key': 620100,
    'label': '兰州市'
  }, {
    'key': 620200,
    'label': '嘉峪关市'
  }, {
    'key': 620300,
    'label': '金昌市'
  }, {
    'key': 620400,
    'label': '白银市'
  }, {
    'key': 620500,
    'label': '天水市'
  }, {
    'key': 620600,
    'label': '武威市'
  }, {
    'key': 620700,
    'label': '张掖市'
  }, {
    'key': 620800,
    'label': '平凉市'
  }, {
    'key': 620900,
    'label': '酒泉市'
  }, {
    'key': 621000,
    'label': '庆阳市'
  }, {
    'key': 621100,
    'label': '定西市'
  }, {
    'key': 621200,
    'label': '陇南市'
  }, {
    'key': 622900,
    'label': '临夏回族自治州'
  }, {
    'key': 623000,
    'label': '甘南藏族自治州'
  }]
}, {
  'key': 630000,
  'label': '青海',
  'children': [{
    'key': 630100,
    'label': '西宁市'
  }, {
    'key': 630200,
    'label': '海东市'
  }, {
    'key': 632200,
    'label': '海北藏族自治州'
  }, {
    'key': 632300,
    'label': '黄南藏族自治州'
  }, {
    'key': 632500,
    'label': '海南藏族自治州'
  }, {
    'key': 632600,
    'label': '果洛藏族自治州'
  }, {
    'key': 632700,
    'label': '玉树藏族自治州'
  }, {
    'key': 632800,
    'label': '海西蒙古族藏族自治州'
  }]
}, {
  'key': 640000,
  'label': '宁夏',
  'children': [{
    'key': 640100,
    'label': '银川市'
  }, {
    'key': 640200,
    'label': '石嘴山市'
  }, {
    'key': 640300,
    'label': '吴忠市'
  }, {
    'key': 640400,
    'label': '固原市'
  }, {
    'key': 640500,
    'label': '中卫市'
  }]
}, {
  'key': 650000,
  'label': '新疆',
  'children': [{
    'key': 650100,
    'label': '乌鲁木齐市'
  }, {
    'key': 650200,
    'label': '克拉玛依市'
  }, {
    'key': 650400,
    'label': '吐鲁番市'
  }, {
    'key': 650500,
    'label': '哈密市'
  }, {
    'key': 652300,
    'label': '昌吉回族自治州'
  }, {
    'key': 652700,
    'label': '博尔塔拉蒙古自治州'
  }, {
    'key': 652800,
    'label': '巴音郭楞蒙古自治州'
  }, {
    'key': 652900,
    'label': '阿克苏地区'
  }, {
    'key': 653000,
    'label': '克孜勒苏柯尔克孜自治州'
  }, {
    'key': 653100,
    'label': '喀什地区'
  }, {
    'key': 653200,
    'label': '和田地区'
  }, {
    'key': 654000,
    'label': '伊犁哈萨克自治州'
  }, {
    'key': 654200,
    'label': '塔城地区'
  }, {
    'key': 654300,
    'label': '阿勒泰地区'
  }, {
    'key': 659001,
    'label': '石河子市'
  }, {
    'key': 659002,
    'label': '阿拉尔市'
  }, {
    'key': 659003,
    'label': '图木舒克市'
  }, {
    'key': 659004,
    'label': '五家渠市'
  }, {
    'key': 659005,
    'label': '北屯市'
  }, {
    'key': 659006,
    'label': '铁门关市'
  }, {
    'key': 659007,
    'label': '双河市'
  }, {
    'key': 659008,
    'label': '可克达拉市'
  }]
}, {
  'key': 710000,
  'label': '台湾'
}, {
  'key': 810000,
  'label': '香港'
}, {
  'key': 820000,
  'label': '澳门'
}, {
  'key': 900000,
  'label': '国外',
  'children': [{
    'key': 951002,
    'label': '日本'
  }, {
    'key': 951003,
    'label': '朝鲜'
  }, {
    'key': 951004,
    'label': '韩国'
  }, {
    'key': 951005,
    'label': '蒙古国'
  }, {
    'key': 952001,
    'label': '缅甸'
  }, {
    'key': 952002,
    'label': '文莱'
  }, {
    'key': 952003,
    'label': '柬埔寨'
  }, {
    'key': 952004,
    'label': '东帝汶'
  }, {
    'key': 952005,
    'label': '印度尼西亚'
  }, {
    'key': 952006,
    'label': '老挝'
  }, {
    'key': 952007,
    'label': '马来西亚'
  }, {
    'key': 952008,
    'label': '菲律宾'
  }, {
    'key': 952009,
    'label': '新加坡'
  }, {
    'key': 952010,
    'label': '泰国'
  }, {
    'key': 952011,
    'label': '越南'
  }, {
    'key': 953001,
    'label': '孟加拉国'
  }, {
    'key': 953002,
    'label': '不丹'
  }, {
    'key': 953003,
    'label': '印度'
  }, {
    'key': 953004,
    'label': '马尔代夫'
  }, {
    'key': 953005,
    'label': '尼泊尔'
  }, {
    'key': 953006,
    'label': '巴基斯坦'
  }, {
    'key': 953007,
    'label': '斯里兰卡'
  }, {
    'key': 954001,
    'label': '哈萨克斯坦'
  }, {
    'key': 954002,
    'label': '吉尔吉斯斯坦'
  }, {
    'key': 954003,
    'label': '塔吉克斯坦'
  }, {
    'key': 954004,
    'label': '土库曼斯坦'
  }, {
    'key': 954005,
    'label': '乌兹别克斯坦'
  }, {
    'key': 955001,
    'label': '阿富汗'
  }, {
    'key': 955002,
    'label': '亚美尼亚'
  }, {
    'key': 955003,
    'label': '阿塞拜疆'
  }, {
    'key': 955004,
    'label': '巴林'
  }, {
    'key': 955005,
    'label': '塞浦路斯'
  }, {
    'key': 955006,
    'label': '格鲁吉亚'
  }, {
    'key': 955007,
    'label': '伊朗'
  }, {
    'key': 955008,
    'label': '伊拉克'
  }, {
    'key': 955009,
    'label': '以色列'
  }, {
    'key': 955010,
    'label': '约旦'
  }, {
    'key': 955011,
    'label': '科威特'
  }, {
    'key': 955012,
    'label': '黎巴嫩'
  }, {
    'key': 955013,
    'label': '阿曼'
  }, {
    'key': 955014,
    'label': '巴勒斯坦'
  }, {
    'key': 955015,
    'label': '卡塔尔'
  }, {
    'key': 955016,
    'label': '沙特阿拉伯'
  }, {
    'key': 955017,
    'label': '叙利亚'
  }, {
    'key': 955018,
    'label': '土耳其'
  }, {
    'key': 955019,
    'label': '阿联酋'
  }, {
    'key': 955020,
    'label': '也门'
  }, {
    'key': 961001,
    'label': '比利时'
  }, {
    'key': 961002,
    'label': '法国'
  }, {
    'key': 961003,
    'label': '爱尔兰'
  }, {
    'key': 961004,
    'label': '卢森堡'
  }, {
    'key': 961005,
    'label': '摩纳哥'
  }, {
    'key': 961006,
    'label': '荷兰'
  }, {
    'key': 961007,
    'label': '英国'
  }, {
    'key': 962001,
    'label': '丹麦'
  }, {
    'key': 962002,
    'label': '芬兰'
  }, {
    'key': 962003,
    'label': '冰岛'
  }, {
    'key': 962004,
    'label': '挪威'
  }, {
    'key': 962005,
    'label': '瑞典'
  }, {
    'key': 963001,
    'label': '奥地利'
  }, {
    'key': 963002,
    'label': '捷克'
  }, {
    'key': 963003,
    'label': '德国'
  }, {
    'key': 963004,
    'label': '匈牙利'
  }, {
    'key': 963005,
    'label': '列支敦士登'
  }, {
    'key': 963006,
    'label': '波兰'
  }, {
    'key': 963007,
    'label': '斯洛伐克'
  }, {
    'key': 963008,
    'label': '瑞士'
  }, {
    'key': 964001,
    'label': '白俄罗斯'
  }, {
    'key': 964002,
    'label': '爱沙尼亚'
  }, {
    'key': 964003,
    'label': '拉脱维亚'
  }, {
    'key': 964004,
    'label': '立陶宛'
  }, {
    'key': 964005,
    'label': '摩尔多瓦'
  }, {
    'key': 964006,
    'label': '俄罗斯'
  }, {
    'key': 964007,
    'label': '乌克兰'
  }, {
    'key': 965001,
    'label': '阿尔巴尼亚'
  }, {
    'key': 965002,
    'label': '安道尔'
  }, {
    'key': 965003,
    'label': '波黑'
  }, {
    'key': 965004,
    'label': '保加利亚'
  }, {
    'key': 965005,
    'label': '克罗地亚'
  }, {
    'key': 965007,
    'label': '希腊'
  }, {
    'key': 965008,
    'label': '意大利'
  }, {
    'key': 965009,
    'label': '马其顿'
  }, {
    'key': 965010,
    'label': '葡萄牙'
  }, {
    'key': 965011,
    'label': '罗马尼亚'
  }, {
    'key': 965012,
    'label': '圣马力诺'
  }, {
    'key': 965013,
    'label': '塞尔维亚'
  }, {
    'key': 965014,
    'label': '斯洛文尼亚'
  }, {
    'key': 965015,
    'label': '西班牙'
  }, {
    'key': 965017,
    'label': '梵蒂冈'
  }, {
    'key': 965018,
    'label': '黑山'
  }, {
    'key': 965019,
    'label': '马耳他'
  }, {
    'key': 971001,
    'label': '加拿大'
  }, {
    'key': 971002,
    'label': '美国'
  }, {
    'key': 971003,
    'label': '墨西哥'
  }, {
    'key': 972001,
    'label': '伯利兹'
  }, {
    'key': 972002,
    'label': '哥斯达黎加'
  }, {
    'key': 972003,
    'label': '萨尔瓦多'
  }, {
    'key': 972004,
    'label': '危地马拉'
  }, {
    'key': 972005,
    'label': '洪都拉斯'
  }, {
    'key': 972006,
    'label': '尼加拉瓜'
  }, {
    'key': 972007,
    'label': '巴拿马'
  }, {
    'key': 973001,
    'label': '阿根廷'
  }, {
    'key': 973002,
    'label': '玻利维亚'
  }, {
    'key': 973003,
    'label': '巴西'
  }, {
    'key': 973004,
    'label': '智利'
  }, {
    'key': 973005,
    'label': '哥伦比亚'
  }, {
    'key': 973006,
    'label': '厄瓜多尔'
  }, {
    'key': 973007,
    'label': '圭亚那'
  }, {
    'key': 973008,
    'label': '秘鲁'
  }, {
    'key': 973009,
    'label': '巴拉圭'
  }, {
    'key': 973010,
    'label': '苏里南'
  }, {
    'key': 973011,
    'label': '乌拉圭'
  }, {
    'key': 973012,
    'label': '委內瑞拉'
  }, {
    'key': 974001,
    'label': '安提瓜和巴布达'
  }, {
    'key': 974002,
    'label': '巴哈马'
  }, {
    'key': 974003,
    'label': '巴巴多斯'
  }, {
    'key': 974004,
    'label': '古巴'
  }, {
    'key': 974005,
    'label': '多米尼克'
  }, {
    'key': 974006,
    'label': '多米尼加'
  }, {
    'key': 974007,
    'label': '格林纳达'
  }, {
    'key': 974008,
    'label': '海地'
  }, {
    'key': 974009,
    'label': '牙买加'
  }, {
    'key': 974010,
    'label': '圣基茨和尼维斯'
  }, {
    'key': 974011,
    'label': '圣卢西亚'
  }, {
    'key': 974012,
    'label': '圣文森特和格林纳丁斯'
  }, {
    'key': 974013,
    'label': '特立尼达和多巴哥'
  }, {
    'key': 981001,
    'label': '阿尔及利亚'
  }, {
    'key': 981002,
    'label': '埃及'
  }, {
    'key': 981003,
    'label': '利比亚'
  }, {
    'key': 981004,
    'label': '摩洛哥'
  }, {
    'key': 981005,
    'label': '苏丹'
  }, {
    'key': 981006,
    'label': '突尼斯'
  }, {
    'key': 981007,
    'label': '南苏丹'
  }, {
    'key': 982001,
    'label': '贝宁'
  }, {
    'key': 982002,
    'label': '布基纳法索'
  }, {
    'key': 982003,
    'label': '乍得'
  }, {
    'key': 982004,
    'label': '科特迪瓦'
  }, {
    'key': 982005,
    'label': '冈比亚'
  }, {
    'key': 982006,
    'label': '加纳'
  }, {
    'key': 982007,
    'label': '几內亚'
  }, {
    'key': 982008,
    'label': '几内亚比绍'
  }, {
    'key': 982009,
    'label': '利比里亚'
  }, {
    'key': 982010,
    'label': '马里'
  }, {
    'key': 982011,
    'label': '尼日尔'
  }, {
    'key': 982012,
    'label': '毛里塔尼亚'
  }, {
    'key': 982013,
    'label': '尼日利亚'
  }, {
    'key': 982014,
    'label': '塞内加尔'
  }, {
    'key': 982015,
    'label': '塞拉利昂'
  }, {
    'key': 982016,
    'label': '多哥'
  }, {
    'key': 982017,
    'label': '佛得角'
  }, {
    'key': 983001,
    'label': '喀麦隆'
  }, {
    'key': 983002,
    'label': '中非共和国'
  }, {
    'key': 983003,
    'label': '赤道几內亚'
  }, {
    'key': 983004,
    'label': '加蓬'
  }, {
    'key': 983005,
    'label': '刚果共和国'
  }, {
    'key': 983006,
    'label': '刚果民主共和国'
  }, {
    'key': 983007,
    'label': '圣多美和普林西比'
  }, {
    'key': 984001,
    'label': '安哥拉'
  }, {
    'key': 984002,
    'label': '博茨瓦纳'
  }, {
    'key': 984003,
    'label': '科摩罗'
  }, {
    'key': 984004,
    'label': '莱索托'
  }, {
    'key': 984005,
    'label': '马达加斯加'
  }, {
    'key': 984006,
    'label': '马拉维'
  }, {
    'key': 984008,
    'label': '莫桑比克'
  }, {
    'key': 984009,
    'label': '纳米比亚'
  }, {
    'key': 984010,
    'label': '斯威士兰'
  }, {
    'key': 984011,
    'label': '南非'
  }, {
    'key': 984012,
    'label': '赞比亚'
  }, {
    'key': 984013,
    'label': '津巴布韦'
  }, {
    'key': 984014,
    'label': '毛里求斯'
  }, {
    'key': 985001,
    'label': '布隆迪'
  }, {
    'key': 985002,
    'label': '吉布提'
  }, {
    'key': 985003,
    'label': '厄立特里亚'
  }, {
    'key': 985004,
    'label': '埃塞俄比亚'
  }, {
    'key': 985005,
    'label': '肯尼亚'
  }, {
    'key': 985006,
    'label': '卢旺达'
  }, {
    'key': 985007,
    'label': '塞舌尔'
  }, {
    'key': 985008,
    'label': '索马里'
  }, {
    'key': 985009,
    'label': '坦桑尼亚'
  }, {
    'key': 985010,
    'label': '乌干达'
  }, {
    'key': 990001,
    'label': '澳大利亚'
  }, {
    'key': 990002,
    'label': '斐济'
  }, {
    'key': 990003,
    'label': '基里巴斯'
  }, {
    'key': 990004,
    'label': '马绍尔群岛'
  }, {
    'key': 990005,
    'label': '密克罗尼西亚联邦'
  }, {
    'key': 990006,
    'label': '瑙鲁'
  }, {
    'key': 990007,
    'label': '新西兰'
  }, {
    'key': 990008,
    'label': '帕劳'
  }, {
    'key': 990009,
    'label': '巴布亚新几内亚'
  }, {
    'key': 990010,
    'label': '萨摩亚'
  }, {
    'key': 990011,
    'label': '所罗门群岛'
  }, {
    'key': 990012,
    'label': '汤加'
  }, {
    'key': 990013,
    'label': '图瓦卢'
  }, {
    'key': 990014,
    'label': '瓦努阿图'
  }]
}]



// WEBPACK FOOTER //
// ./src/data/location.js